<template>
  <div class="level">
    <div class="level__wrapper">
      <LevelTitle :title="title" />
      <div class="level__details-wrapper">
        <Action
          @click="toggleIFrame"
          ofType="trigger"
          content=""
          :class="!hasAccess ? 'action__trigger--disabled' : ''"
          :disabled="!hasAccess"
          :isLoading="isLoading"
          v-tooltip="{
            content: `Open ${iFrame.type}`,
            placement: 'bottom-center',
          }"
        >
          <template v-slot:icon>
            <IFrameIcon :fill="hasCompleted()" class="level__icon" />
          </template>
        </Action>
        <LevelControl
          @click="toggleIFrame"
          :isLoading="isLoading"
          :hasAccess="hasAccess"
          :isContentActive="isWatching"
          :statusText="stateText"
          :status="iFrameStatus"
          :plansLink="plansLink"
          :courseStatus="courseStatus"
        />
      </div>
    </div>
    <div class="level__content">
      <MediaDelegate
        v-if="isWatching"
        v-bind="{
          parentType: 'course',
          content: iFrame,
          userCompletionStatus: iFrameStatus,
        }"
        @is-loading="setLoader"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import IFrameIcon from '@/assets/icons/course/iframe/iframe-icon.svg'
import Action from '@/components/shared/Action.vue'
import CONSTANTS from '@/constants'
import MediaDelegate from '@/components/media/MediaDelegate.vue'
import LevelTitle from './level/LevelTitle.vue'
import LevelControl from './level/LevelControl.vue'

export default {
  name: 'IFrameLevel',
  data() {
    return {
      isLoading: false,
    }
  },
  components: {
    LevelTitle,
    LevelControl,
    IFrameIcon: { ...IFrameIcon, name: 'IFrameIcon' },
    MediaDelegate,
    Action,
  },
  props: {
    courseId: {
      type: String,
      required: true,
    },
    courseStatus: {
      type: String,
      required: true,
    },
    iFrame: {
      type: Object,
      required: true,
    },
    iFrameStatus: {
      type: String,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      playingIFrameId: state => state.iframes.playingIFrameId,
    }),
    stateText() {
      if (this.iFrameStatus === CONSTANTS.CONTENT_USER_STATUS.STARTED) {
        return 'Resume'
      }
      return 'Open'
    },
    isWatching() {
      return this.iFrame.id === this.playingIFrameId
    },
  },
  methods: {
    async toggleIFrame() {
      if (this.playingIFrameId === this.iFrame.id) {
        this.$store.dispatch('iframes/setPlayingIFrameId', '')
      } else {
        this.$store.dispatch('iframes/setPlayingIFrameId', this.iFrame.id)
      }
      this.$store.dispatch('content/setPlayingVideoId', '')
      this.$store.dispatch('content/setCurrentQuizId', '')
    },
    isContentSelected() {
      if (this.isLoading) {
        return 'level__trigger level__trigger--disabled'
      }
      if (this.isWatching) {
        return 'level__trigger level__trigger--selected'
      }
      return 'level__trigger'
    },
    hasCompleted() {
      if (!this.hasAccess) return '#3A3A3A'
      return this.iFrameStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED
        ? '#00DEA0'
        : '#808080'
    },
    setLoader(state) {
      this.isLoading = state
    },
  },
}
</script>
